import React from 'react';
import LegalPageLayout, { LegalSection, LegalList } from '../components/LegalPageLayout';

const GDPR: React.FC = () => (
  <LegalPageLayout title="GDPR Compliance" lastUpdated="April 17, 2026">
    <LegalSection title="1. Data Controller">
      <p>Sahayy acts as the data controller for personal data collected through our application and website. We are committed to protecting your privacy in accordance with the General Data Protection Regulation (GDPR).</p>
    </LegalSection>

    <LegalSection title="2. Legal Basis for Processing">
      <p>We process your personal data based on the following legal grounds:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Consent:</strong> When you create an account and agree to our terms.</>,
        <><strong style={{ color: "#111827" }}>Contract:</strong> To provide the services you have requested.</>,
        <><strong style={{ color: "#111827" }}>Legitimate Interest:</strong> To improve our services and ensure security.</>,
        <><strong style={{ color: "#111827" }}>Legal Obligation:</strong> To comply with applicable laws and regulations.</>,
      ]} />
    </LegalSection>

    <LegalSection title="3. Your Rights Under GDPR">
      <p>As a data subject, you have the following rights:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Right of Access:</strong> Request a copy of your personal data.</>,
        <><strong style={{ color: "#111827" }}>Right to Rectification:</strong> Request correction of inaccurate data.</>,
        <><strong style={{ color: "#111827" }}>Right to Erasure:</strong> Request deletion of your personal data ("right to be forgotten"). You can delete your account directly from the app under Settings.</>,
        <><strong style={{ color: "#111827" }}>Right to Restriction:</strong> Request limitation of processing of your data.</>,
        <><strong style={{ color: "#111827" }}>Right to Data Portability:</strong> Request your data in a machine-readable format.</>,
        <><strong style={{ color: "#111827" }}>Right to Object:</strong> Object to processing based on legitimate interest.</>,
        <><strong style={{ color: "#111827" }}>Right to Withdraw Consent:</strong> Withdraw consent at any time without affecting prior processing.</>,
      ]} />
    </LegalSection>

    <LegalSection title="4. Data We Collect">
      <p>We collect and process the following categories of personal data:</p>
      <LegalList items={[
        <><strong style={{ color: "#111827" }}>Account Data:</strong> Name, email address, phone number, nationality, city.</>,
        <><strong style={{ color: "#111827" }}>Profile Data:</strong> Avatar, community preferences.</>,
        <><strong style={{ color: "#111827" }}>Content Data:</strong> Events, services, groups, and marketplace listings you create.</>,
        <><strong style={{ color: "#111827" }}>Usage Data:</strong> How you interact with the app (anonymized).</>,
        <><strong style={{ color: "#111827" }}>Location Data:</strong> City-level location for community features (with your consent).</>,
      ]} />
    </LegalSection>

    <LegalSection title="5. Data Storage and Transfer">
      <p>Your data is stored on Amazon Web Services (AWS) servers located in the European Union (Ireland, London, Frankfurt). We do not transfer personal data outside the EU/EEA without appropriate safeguards.</p>
    </LegalSection>

    <LegalSection title="6. Data Retention">
      <p>We retain your personal data only for as long as necessary to provide our services. When you delete your account, your personal data is permanently removed within 30 days.</p>
    </LegalSection>

    <LegalSection title="7. Data Protection Officer">
      <p>For any GDPR-related inquiries or to exercise your rights, please contact us:</p>
      <p>Email: <a href="mailto:care@sahayy.com" style={{ color: '#FF9900' }}>care@sahayy.com</a></p>
    </LegalSection>

    <LegalSection title="8. Supervisory Authority">
      <p>If you believe your data protection rights have been violated, you have the right to lodge a complaint with your local data protection supervisory authority.</p>
    </LegalSection>
  </LegalPageLayout>
);

export default GDPR;
